import { useEffect, useMemo, useState } from 'react';
import { Card } from './ui/card';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from './ui/table';
import Axios from '../Axios';
const tabs = [
  { id: 'daily', label: 'Daily' },
  { id: 'weekly', label: 'Weekly' },
  { id: 'allTime', label: 'AllTime' }
];
export function LeaderboardPage() {

  const [activePeriod, setActivePeriod] = useState('daily');
  const [leaderboardData, setLeaderboardData] = useState([]);
  const getLeaderboardData = async () => {
    try {
      const { data } = await Axios.post('/users/get-leaderboard', {
        limit: 10,
        type: activePeriod
      });
      if (data?.success) {
        setLeaderboardData(data?.result || []);
      } else {
        setLeaderboardData([]);
      }
    }
    catch (error) {
      setLeaderboardData([]);
      console.error('Error fetching leaderboard data:', error);
    }
  };

  useEffect(() => {
    getLeaderboardData();
  }, [activePeriod]);

  const rows = useMemo(() => {
    return leaderboardData.map((entry, index) => {
      const traderName = entry?.user?.name || 'Unknown Trader';
      return {
        rank: index + 1,
        initials: getInitials(traderName),
        trader: traderName,
        profit: Number(entry?.overallProfit || 0),
        trades: Number(entry?.totalTrades || 0),
        winRate: Number(entry?.winPercentage || 0),
        wins: Number(entry?.wins || 0)
      };
    });
  }, [leaderboardData]);

  const first = rows.find((entry) => entry.rank === 1);
  const second = rows.find((entry) => entry.rank === 2);
  const third = rows.find((entry) => entry.rank === 3);
  const podium = useMemo(() => [second, first, third].filter(Boolean), [first, second, third]);


  return (<section className="leaderboard-page">
    <header className="leaderboard-header">
      <h1>Leaderboard</h1>
      <p>Top performing traders</p>
    </header>

    <div className="leaderboard-tabs" role="tablist" aria-label="Leaderboard period">
      {tabs.map((tab) => (<button key={tab.id} type="button" role="tab" aria-selected={activePeriod === tab.id} className={`leaderboard-tab ${activePeriod === tab.id ? 'is-active' : ''}`} onClick={() => setActivePeriod(tab.id)}>
        {tab.label}
      </button>))}
    </div>

    <section className="leaderboard-podium">
      {podium.map((entry) => (<Card as="article" key={`${activePeriod}-${entry.rank}-${entry.trader}`} className={`podium-card podium-card--rank-${entry.rank}`}>
        <div className="podium-avatar">{entry.initials}</div>
        <p className="podium-rank">{entry.rank}</p>
        <h2>{entry.trader}</h2>
        <strong>{toUsd(entry.profit)}</strong>
        <small>{entry.trades} trades • {entry.winRate.toFixed(1)}% win • {entry.wins} wins</small>
      </Card>))}
    </section>

    <section className="leaderboard-rankings">
      <h3>{tabs.find((tab) => tab.id === activePeriod)?.label} Rankings</h3>
      <Table className="leaderboard-table">
        <TableHeader>
          <TableHead>Rank</TableHead>
          <TableHead>Trader</TableHead>
          <TableHead>Profit</TableHead>
          <TableHead>Trades</TableHead>
        </TableHeader>
        <TableBody>
          {rows.map((entry) => (<TableRow key={`${activePeriod}-${entry.rank}-row`}>
            <TableCell as="strong">#{entry.rank}</TableCell>
            <TableCell as="p">
              <span className="table-avatar">{entry.initials}</span>
              <span>{entry.trader}</span>
            </TableCell>
            <TableCell as="strong" className="meta-up">{toUsd(entry.profit)}</TableCell>
            <TableCell>{entry.trades}</TableCell>
          </TableRow>))}
        </TableBody>
      </Table>
    </section>
  </section>);
}
function toUsd(value) {
  return Number(value || 0).toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
}

function getInitials(name) {
  return String(name || '')
    .split(' ')
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase() || '')
    .join('') || '--';
}
